<template>
  <el-drawer :withHeader="false" :visible.sync="open" direction="rtl" :before-close="handleClose" size="666px">
    <!-- <div class="close">
      收起
    </div> -->
    <div class="drawer-header">
      <div style="padding-top:20px;display: flex;">
        <div class="start-label" />
        <span class="text">查看用户详情</span>
      </div>
    </div>
    <div class="info">
      <div class="triangle"></div>
      <div class="info-conten">
        <span>关联科室: </span>
        <span style="margin-left:10px" v-for="(item, index) in form.deptInfos" :key="index + 'w'">{{item.name}}</span><br />
        <span>关联库房: </span>
        <span style="margin-left:10px" v-for="(item, index) in form.warehouseInfos" :key="index">{{item.name}}</span><br />
        <span>启用状态：</span>
        <span style="margin-left:10px" :class="{enable: form.state==1}">已{{form.stateName}}</span>
      </div>
    </div>

    <div style="margin-left:20px;margin-top:10px">
      <div class="badge">基础信息</div>
      <div style="margin-top:0px">
        <el-form label-width="100px">
          <el-form-item label="工号:" prop="no">
            <span class="value">{{form.no}}</span>
          </el-form-item>
          <el-form-item label="姓名:" prop="name">
            <span class="value">{{form.name}}</span>
          </el-form-item>
          <el-form-item label="身份证号:" prop="idcard">
            <span class="value">{{form.idcard}}</span>
          </el-form-item>
          <el-form-item label="联系方式:" prop="mobile">
            <span class="value">{{form.mobile}}</span>
          </el-form-item>
          <el-form-item label="性别:">
            <span class="value">{{form.sexName}}</span>
          </el-form-item>
          <el-form-item label="所属科室:">
            <span class="value">{{form.deptName}}</span>
          </el-form-item>
          <el-form-item label="系统权限">
            <span class="value">{{form.systemPower==0?'耗材':form.systemPower==1?'药品':'全部'}}</span>
          </el-form-item>
          <el-form-item label="打印设置:">
            <span class="value">{{form.printSettingName}}</span>
          </el-form-item>
          <el-form-item label="所属角色:">
            <!-- <span class="value">{{form.printSettingName}}</span> -->
            <div class="role-group">
              <div class="role" :class="getType(index)" v-for="(item, index) in form.roleInfos" :key="index">
                {{ item.name }}
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>

  </el-drawer>
</template>

<script>
import { GetUserById } from '@/api';

export default {
  name: 'user-info',
  data () {
    return {
      open: false,
      form: {}
    }
  },
  props: {
    show: {
      type: Boolean,
      default () {
        return false
      }
    },
    id: {
      type: Number,
      default () {
        return 0
      }
    }
  },
  watch: {
    'show' (val, oldVal) {
      this.open = val

      if (this.open) {
        this.getInfo()
      }
    },
  },
  methods: {
    handleClose () {
      this.$emit('handleClose');
    },
    getInfo () {
      GetUserById({ id: this.id }).then(res => {
        this.resetForm()
        this.form = res.returnData
        if(this.form.systemPower == ''||this.form.systemPower== null){
          this.form.systemPower = 0
        }
      })
    },
    resetForm () {
      this.form = {
        orgCode :sessionStorage.getItem('orgId'),
      }
    },
    getType (index) {
      let num = index % 5;
      switch (num) {
        case 0:
          return "default";
        case 1:
          return "success";
        case 2:
          return "warning";
        case 3:
          return "enable";
        case 4:
          return "danger";
      }
    },
  }
}
</script>

<style scoped>
/* .close {
  width: 43px;
  height: 152px;
  border-right: 43px solid red;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;
  float: left;
  background: rgba(0, 0, 0, 0.64);
}
.drawer-content {
  float: right;
  width: 662px;
  height: 100%;
} */

div /deep/ .el-form-item__content {
  line-height: 20px !important;
  color: #606166;
  font-weight: 400;
}
div /deep/ .el-form-item__label {
  padding-bottom: 0 !important;
  line-height: 20px !important;
}
.el-form-item {
  margin-bottom: 5px !important;
}
</style>